import { PrintSettings } from "../../interfaces/print";

export const getLegendPlacement = (settings: PrintSettings) => settings.legend && settings.legend.placement;
